import useSWR from 'swr';
import { fetchEndpointData } from '@/utils/fetch.client';

export interface SandboxStatusCounts {
  none: number;
  provisioning: number;
  ready: number;
  stopping: number;
  stopped: number;
  archived: number;
  error: number;
}

export interface TopTeamRow {
  id: string;
  name: string;
  slug: string;
  workspace_count: number;
}

export interface RecentSignup {
  id: string;
  email: string;
  name: string;
  created_at: string;
}

export interface AdminStats {
  total_users: number;
  total_teams: number;
  total_repositories: number;
  /** Spaces with nothing left to spend — agent work in these is stopping. */
  exhausted_teams: number;
  total_workspaces: number;
  sandbox_statuses: SandboxStatusCounts;
  top_teams: TopTeamRow[];
  recent_signups: RecentSignup[];
}

export function useAdminStats() {
  const { data, mutate, isLoading, error } = useSWR('/api/v1/admin/stats', () =>
    fetchEndpointData<AdminStats>('/api/v1/admin/stats'),
  );
  return { stats: data, mutate, isLoading, error };
}
